import {
    GET_PIN_VALIDATION_REQUEST,
    GET_PIN_VALIDATION_RESPONSE_SUCCESS,
    GET_PIN_VALIDATION_RESPONSE_FAIL
} from "./pinValidationTypes";

const initialState = {
    pinValidationData: {},
    statusCode: Number,
    responseMsg: "",
    exceptionMessage: "",
    loading: false
}

const pinValidationReducer = (state = initialState, action) => {

    switch (action.type) {
        case GET_PIN_VALIDATION_REQUEST:
            return {
                ...state,
                loading: true
            }
            break;
        case GET_PIN_VALIDATION_RESPONSE_SUCCESS:
            return {
                ...state,
                pinValidationData: action.payload.data,
                statusCode: action.payload.statusCode,
                responseMsg: action.payload.responseMsg,
                exceptionMessage: action.payload.exceptionMessage,
                loading: false
            }
            break;
        default:
            return state;
    }
}

export default pinValidationReducer
